import { type Configuration, type RedirectRequest } from "@azure/msal-browser";

export interface RuntimeConfig {
    auth_enabled: boolean;
    entra_tenant_id?: string;
    entra_client_id?: string;
    /** The API accepts the Media Manager's sign-in, which the app takes in its frame. */
    media_manager_sign_in?: boolean;
}

export const createMsalConfig = (config: RuntimeConfig): Configuration => {
    const tenantId = config.entra_tenant_id;
    const clientId = config.entra_client_id;

    return {
        auth: {
            clientId: clientId || "dummy-client-id",
            authority: `https://login.microsoftonline.com/${tenantId || "common"}`,
            redirectUri: window.location.origin,
        },
        cache: {
            // Shared by the app's tabs. Since MSAL 4 the entries are encrypted
            // with a session cookie, so a sign-in lasts until the browser closes.
            cacheLocation: "localStorage",
        },
    };
};

export const createLoginRequest = (): RedirectRequest => {
    // We use User.Read to get the profile.
    // We will use the ID Token for backend auth (since backend accepts Client ID as audience).
    const scopes = ["User.Read"];
    return {
        scopes,
        prompt: "select_account"
    };
};
